"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelPartialWithIdSchema = exports.ChannelSchema = exports.AttributesSettingsSchema = exports.ChannelAttributeSettingsSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.ChannelAttributeSettingsSchema = zod_1.z.object({
    editableWithSales: zod_1.z.boolean().optional(),
});
exports.AttributesSettingsSchema = zod_1.z.record(zod_1.z.nativeEnum(__1.EChannelAttributeKey), exports.ChannelAttributeSettingsSchema);
exports.ChannelSchema = __1.BaseSchema.extend({
    name: __1.ShortStringSchema,
    /**
     * The object which contains attributes with some channels specific definitions
     *
     * @exampleValue
     * attributeSettings: {
     *  [EChannelAttributeKey.Key]: {
     *    editable: true
     *  }
     * }
     */
    attributeSettings: exports.AttributesSettingsSchema.optional(),
    type: zod_1.z.nativeEnum(__1.ChannelType),
    authUrl: __1.LongStringSchema.url().optional(),
    countryCode: zod_1.z.nativeEnum(__1.Alpha3Countries).optional(),
    serviceBasePath: zod_1.z
        .enum(['channel-amazon', 'channel-mercadolibre', 'channel-shopee', 'channel-shopify', 'channel-storefront'])
        .optional(),
    description: zod_1.z.array(__1.ShortStringSchema).optional(),
    isStoreUrlRequired: zod_1.z.boolean().optional(),
    isComingSoon: zod_1.z.boolean().optional(),
    readMoreUrl: __1.LongStringSchema.url().optional(),
    channelImageUrl: __1.LongStringSchema.url().optional(),
    channelAccountStatusUrl: __1.LongStringSchema.url().optional(),
    channelPickUpInstructionsUrl: __1.LongStringSchema.url().optional(),
    channelPickUpSettingsUrl: __1.LongStringSchema.url().optional(),
    /**
     * @deprecated Type error (Comissions -> Commissions)
     */
    channelPlansAndComissionsUrl: __1.LongStringSchema.url().optional(),
    channelPlansAndCommissionsUrl: __1.LongStringSchema.url().optional(),
    channelShippingSettingsUrl: __1.LongStringSchema.url().optional(),
    channelStoreDetailsUrl: __1.LongStringSchema.url().optional(),
});
exports.ChannelPartialWithIdSchema = exports.ChannelSchema.partial().required({ id: true });
//# sourceMappingURL=index.js.map